export default __webpack_public_path__ + "static/media/headerbg.2574e58e.png";